import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import SideNavigationLabel from "../side/SideNavigationLabel";
import SideNavigationToggle from "../side/SideNavigationToggle";
import SideNavigationNavLink from "../side/SideNavigationNavLink";

import FileUploadList from "./FileUploadList";
import FileUpload from "./FileUpload";
import UserList from "./UserList";
import UserView from './UserView';
import AdminList from "./AdminList";
import AdminEntry from "./AdminEntry";
import AlertList from "./AlertList";
import AlertEntry from "./AlertEntry";
import AlertView from "./AlertView";
import EmailList from "./EmailList";
import PhoneList from "./PhoneList";

import CommonTop from "../top/CommonTop";

import { FileUploadTenantAdminKey, FileUploadsTenantAdminKey, AdminListTenantAdminKey,  AlertListTenantAdminKey, PhoneListTenantAdminKey, EmailListTenantAdminKey, UserListTenantAdminKey
	} from "../../redux/actions/tenantAdminActions";

import {  userTieActiveIcon, userTieIcon,  userIconBlack,
		bellIcon, bellActiveIcon, bellIconBlack, mobileIcon, mobileActiveIcon, envelopeIcon, envelopeActiveIcon,
		usersIcon, usersActiveIcon, fileUploadIcon, fileUploadActiveIcon, fileUploadIconBlack } from "../../img/font_awesome/font_awesome"
import UserPassword from './UserPassword';


const mapStateToProps = state => {
	return {
		selectedTenantAdminType: state.tenantAdminTypeReducer.selectedTenantAdminType,
		role: state.currentUserReducer.role  
	};
}

class Admin extends React.Component {

	render() {
		let userManagerMenuProps = {
			image: userIconBlack,
			name: "User Manager"
		}

		let alertMenuProps = {
			image: bellIconBlack,
			name: "Alert"
		}

		let fileMenuProps = {
			image: fileUploadIconBlack,
			name: "File Upload"
		}

		let administratorsProps = {
			id: "adminListTenantAdminNavLink",
			link: "/tenantAdmin/Admins",
			selected: this.props.selectedTenantAdminType === AdminListTenantAdminKey,
			image: this.props.selectedTenantAdminType === AdminListTenantAdminKey ? userTieActiveIcon : userTieIcon,
			name: "Administrators"
		}

		let alertsProps = {
			id: "alertListTenantAdminNavLink",
			link: "/tenantAdmin/Alerts",
			selected: this.props.selectedTenantAdminType === AlertListTenantAdminKey,
			image: this.props.selectedTenantAdminType === AlertListTenantAdminKey ? bellActiveIcon : bellIcon,
			name: "Alerts"
		}

		let fileUploadsProps = {
			id: "fileUploadsTenantAdminNavLink",
			link: "/tenantAdmin/FileUploads",
			selected: this.props.selectedTenantAdminType === FileUploadsTenantAdminKey,
			image: this.props.selectedTenantAdminType === FileUploadsTenantAdminKey ? fileUploadActiveIcon : fileUploadIcon,
			name: "File Uploads"
		}

		let emailListProps = {
			id: "emailListTenantAdminNavLink",
			link: "/tenantAdmin/Emails",
			selected: this.props.selectedTenantAdminType === EmailListTenantAdminKey,
			image: this.props.selectedTenantAdminType === EmailListTenantAdminKey ? envelopeActiveIcon : envelopeIcon,
			name: "Alert Emails"
		}

		let phoneListProps = {
			id: "phoneListTenantAdminNavLink",
			link: "/tenantAdmin/Phones",
			selected: this.props.selectedTenantAdminType === PhoneListTenantAdminKey,
			image: this.props.selectedTenantAdminType === PhoneListTenantAdminKey ? mobileActiveIcon : mobileIcon,
			name: "Alert Phones"
		}

		let userListProps = {
			id: "userListTenantAdminNavLink",
			link: "/tenantAdmin/Users",
			selected: this.props.selectedTenantAdminType === UserListTenantAdminKey,
			image: this.props.selectedTenantAdminType === UserListTenantAdminKey ? usersActiveIcon : usersIcon,
			name: "Alert Users"
		}

		let defaultRoute = <Route path="/tenantAdmin" component={AlertList} />;

		if (AdminListTenantAdminKey === this.props.selectedTenantAdminType) {
			defaultRoute = <Route path="/tenantAdmin" component={AdminList} />;
		} else if (AlertListTenantAdminKey === this.props.selectedTenantAdminType) {
			defaultRoute = <Route path="/tenantAdmin" component={AlertList} />;
		} else if (EmailListTenantAdminKey === this.props.selectedTenantAdminType) {
			defaultRoute = <Route path="/tenantAdmin" component={EmailList} />;
		} else if (PhoneListTenantAdminKey === this.props.selectedTenantAdminType) {
			defaultRoute = <Route path="/tenantAdmin" component={PhoneList} />;
		} else if (UserListTenantAdminKey === this.props.selectedTenantAdminType) {
			defaultRoute = <Route path="/tenantAdmin" component={UserList} />;
		} else if (FileUploadsTenantAdminKey === this.props.selectedTenantAdminType) {
			defaultRoute = <Route path="/tenantAdmin" component={FileUploadList} />;
		} 

		return (
			<div>
				<CommonTop history={this.props.history} />
				<div style={{ float: "left", minWidth: 38, maxWidth: 280 }}>
					<SideNavigationToggle />
					<Navbar bg="light" style={{ padding: 0, display: "block" }}>
						<Navbar.Toggle aria-controls="basic-navbar-nav" />
						<Nav className="flex-column" style={{ width: '100%', float: "left", marginLeft: 2 }}>		
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...alertMenuProps} /></Nav.Link>
								<SideNavigationNavLink {...alertsProps} />	
								<SideNavigationNavLink {...emailListProps} />
								<SideNavigationNavLink {...phoneListProps} />		
								<SideNavigationNavLink {...userListProps} />	
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...fileMenuProps} /></Nav.Link>	
								<SideNavigationNavLink {...fileUploadsProps} />				
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...userManagerMenuProps} /></Nav.Link>
								<SideNavigationNavLink {...administratorsProps} />	
						</Nav>
					</Navbar>
				</div>
				<div style={{paddingBottom: 4}}>
					<Switch>
						<Route path="/tenantAdmin/users/:id" component={UserView} />
						<Route path="/tenantAdmin/users" component={UserList} />
						<Route path="/tenantAdmin/adminPassword/:id" component={UserPassword} />
						<Route path="/tenantAdmin/admins/:id" component={AdminEntry} />
						<Route path="/tenantAdmin/admins" component={AdminList} />
						<Route path="/tenantAdmin/alertsView/:id" component={AlertView} />
						<Route path="/tenantAdmin/alerts/:id" component={AlertEntry} />
						<Route path="/tenantAdmin/alerts" component={AlertList} />
						<Route path="/tenantAdmin/emails" component={EmailList} />
						<Route path="/tenantAdmin/phones" component={PhoneList} />
						<Route path="/tenantAdmin/fileUploads" component={FileUploadList} />
						<Route path="/tenantAdmin/fileUpload" component={FileUpload} />
						{defaultRoute}
					</Switch>
				</div>
			</div>	
		);
	}
}

export default connect(mapStateToProps)(Admin);